import React from 'react';
import styles from './AdminCommentList.module.scss';
import AdminTableList from '../../../components/admin/AdminTableList/AdminTableList';
import { userList } from '../../../redux/actions/user/userList';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { postList } from '../../../redux/actions/app/postList';
import Player from 'react-player';
import { discountList } from '../../../redux/actions/app/discountList';
import { commentList } from '../../../redux/actions/app/commentList';
import { Link } from 'react-router-dom';

export const getEventType = (type) => {
  switch (type) {
    case 'TOURNAMENT':
      return 'Турнир';
    case 'BRIEF':
      return 'Сводка';
    case 'KOLCHOZ':
      return 'Колхоз';
    case 'MEETING':
      return 'Встреча';
    case 'POST':
      return 'Пост';
    default:
      break;
  }
};
// export const getEvent

const getStatus = (status, date) => {
  switch (status) {
    case 'CANCELED':
      return { color: '#ef5350', name: 'Отменен' };
    case 'CREATED':
      return { color: '#000', name: 'Создан' };
    case 'COMPLETED':
      return { color: '#ff9800', name: 'Подверждение результатов...' };
    case 'RUNNING':
      return { color: '#42a5f5', name: 'Идет...' };
    case 'ACCEPTED_RESULT':
      return { color: '#4caf50', name: `Завершен ${dayjs(date).format('DD.MM.YYYY HH:mm')}` };

    default:
      break;
  }
};

const getLink = (path, id, status, date) => {
  const statusData = getStatus(status, date);
  return (
    <Box
      style={{ textAlign: 'start', color: statusData.color, fontWeight: 500 }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      // target="_blank"
      // href={`${path}/${id}`}
    >
      {statusData.name}
    </Box>
  );
};

export const getEventLink = (item) => {
  switch (item?.event?.type) {
    case 'TOURNAMENT':
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginRight: 'auto' }}>
          <Box component={'img'} src={item?.event?.tournament?.logo} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '6px', margin: '0 auto' }}></Box>
          <Box sx={{ textAlign: 'left' }}>
            <Box>{item?.event?.tournament?.name}</Box> <Box sx={{ opacity: 0.5, fontSize: '12px' }}>{`${dayjs(item?.event?.tournament?.startDate).format('DD.MM.YYYY')} - ${dayjs(item?.event?.tournament?.endDate).format('DD.MM.YYYY')}`}</Box>
          </Box>
        </Box>
      );
    case 'BRIEF':
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginRight: 'auto' }}>
          <Box component={'img'} src={item?.event?.brief?.creator?.avatar} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
          <Box sx={{ textAlign: 'left' }}>
            <Box>{`${item?.event?.brief?.creator?.lastName} ${item?.event?.brief?.creator?.firstName}`}</Box> <Box sx={{ opacity: 0.5, fontSize: '12px' }}>{`${dayjs(item?.event?.brief?.date).format('DD.MM.YYYY')} (${item?.event?.brief?.startTime} - ${item?.event?.brief?.endTime})`}</Box>
          </Box>
        </Box>
      );
    case 'KOLCHOZ': {
      const game = item?.event?.game;
      return getLink('http://localhost:5173/game', game?.id, game?.status, game?.updatedAt);
    }
    case 'MEETING': {
      const game = item?.event?.meeting;
      return getLink('http://localhost:5173/meeting', game?.id, game?.status, game?.updatedAt);
    }
    case 'POST':
      return (
        <Link
          style={{ width: '200px', textAlign: 'start', textDecorationColor: '#1976d2', color: '#1976d2', textUnderlineOffset: '3px', textOverflow: 'ellipsis', maxWidth: '200px', overflow: 'hidden' }}
          onClick={(e) => {
            e.stopPropagation();
          }}
          to={`/admin/post/edit/${item?.event?.posts?.[0]?.id}`}>
          <Box sx={{ display: 'grid', alignItems: 'center', justifyContent: 'start', gridTemplateColumns: '24px auto', gap: 1 }}>
            <Box component={'img'} src={item?.event?.posts?.[0]?.attachment} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '4px', margin: '0 auto' }}></Box>
            <Box sx={{ textAlign: 'start', textDecorationColor: '#1976d2', color: '#1976d2', textUnderlineOffset: '3px', textOverflow: 'ellipsis', maxWidth: '200px', overflow: 'hidden' }}>{item?.event?.posts?.[0]?.text}</Box>
          </Box>
        </Link>
      );
    default:
      break;
  }
};
const AdminCommentList = () => {
  const columns = [
    {
      label: 'Комментарий',
      onTransform: (val) => <Box sx={{ textAlign: 'left', maxWidth: '300px', width: '300px', whiteSpace: 'normal' }}>{val?.text}</Box>,
    },

    {
      label: 'Автор',
      onTransform: (val) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginRight: 'auto' }}>
          <Box component={'img'} src={val?.creator?.avatar} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
          <Box>{`${val?.creator?.lastName} ${val?.creator?.firstName}`}</Box>
        </Box>
      ),
    },
    {
      label: 'Тип события',
      onTransform: (val) => getEventType(val?.event?.type),
    },
    {
      label: 'Создатель/Статус/Ссылка/Название события',
      onTransform: (val) => getEventLink(val),
    },
    {
      label: 'Дата создания',
      onTransform: (val) => (val?.createdAt ? dayjs(val?.createdAt).format('DD.MM.YYYY HH:mm') : '-'),
    },
  ];
  const deleteProps = { successText: 'Комментарий удален', confirmTitle: `Вы уверены что хотите удалить комментарий`, status: 'DELETED' };
  const blockProps = { successText: 'Комментарий заблокирован', confirmTitle: `Вы уверены что хотите заблокировать комментарий`, status: 'BLOCKED' };
  const unblockProps = { successText: 'Комментарий разблокирован', confirmTitle: `Вы уверены что хотите разблокировать комментарий`, status: 'ACTIVE' };
  return (
    <div>
      <AdminTableList
        isAction
        title={'Комментарии'}
        sliceName={'app'}
        actionName={'commentList'}
        fetch={commentList}
        columns={columns}
        textEmpty={'Комментариев нет'}
        pathList="/admin/comments"
        deleteProps={deleteProps}
        blockProps={blockProps}
        unblockProps={unblockProps}
        propName={'comment'}
        type={'COMMENT'}
      />
    </div>
  );
};

export default AdminCommentList;
